module.exports = __webpack_public_path__ + "static/media/babymassage.dc43f133.jpg";